import {
    GET_PORDUCT_REVIEW_RATING_DETAIL_START,
    GET_PORDUCT_REVIEW_RATING_DETAIL_SUCCESS,
    GET_PORDUCT_REVIEW_RATING_DETAIL_ERROR,
    GET_OPERATOR_REVIEW_RATING_DETAIL_START,
    GET_OPERATOR_REVIEW_RATING_DETAIL_SUCCESS,
    GET_OPERATOR_REVIEW_RATING_DETAIL_ERROR
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: [],
    opratordata:[]
  };
  
  export default function RatingReviewReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case GET_PORDUCT_REVIEW_RATING_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case GET_PORDUCT_REVIEW_RATING_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case GET_PORDUCT_REVIEW_RATING_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
        case GET_OPERATOR_REVIEW_RATING_DETAIL_START:
          return {
            ...state,
            loading: true,
          };
        case GET_OPERATOR_REVIEW_RATING_DETAIL_SUCCESS:
          return {
            ...state,
            opratordata: action.payload,
            loading: false,
          };
        case GET_OPERATOR_REVIEW_RATING_DETAIL_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
      default:
        return state;
    }
  }
  